import styled from "styled-components";
import Modal from "./component";

export default styled(Modal)`
`;
